import type { ReactNode } from "react";
import { SystemState } from "../../shared/components/SystemState";

export function Header({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow: string;
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="module-header">
      <div>
        <span className="section-kicker">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      {action}
    </div>
  );
}

export function EmptyState({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <SystemState title={title} description={description} />
  );
}

export function Outcome({ value }: { value: string }) {
  const successful = value === "SUCCESS" || value === "SENT";
  const waiting = value === "PENDING" || value === "PROCESSING";
  return (
    <span
      className={`admin-state ${successful ? "is-success" : waiting ? "is-warning" : "is-danger"}`}
    >
      {value}
    </span>
  );
}
